/*
 * estoque-checkout-guard.js — confere o estoque no clique de finalizar compra.
 *
 * POR QUE EXISTE. A checagem do Comprar valida a linha no instante em que ela nasce,
 * mas o carrinho FICA PARADO. O cliente monta às 10h e volta às 10h40; nesse meio-tempo
 * o tecido pode ter sido vendido — inclusive no Magento, que é o canal principal
 * enquanto a migração não termina. Nada revalidava isso: o cliente ia ao checkout,
 * pagava, e a falta aparecia no balcão.
 *
 * É também o único ponto que AGREGA: o mesmo tecido em duas linhas (2 m + 3 m) cabe
 * isoladamente em 4 m e não cabe somado. A página do produto não enxerga o carrinho.
 *
 * DELEGAÇÃO NO DOCUMENTO, não listener no botão: o drawer RECONSTRÓI o HTML a cada
 * atualização e troca o nó do botão (`updateMinimumOrderDisplay` chega a substituir um
 * <a> por um <button> e vice-versa). Qualquer listener preso ao elemento morreria na
 * primeira mudança de quantidade — calado, e só na hora de fechar a venda.
 *
 * FALHA ABERTA. Rede fora, servidor fora, resposta estranha: o checkout SEGUE. Isto é
 * rede de segurança, não caixa registradora — travar a venda de todo mundo custa mais
 * do que o pedido excedente que a checagem evitaria. Mesma escolha do servidor.
 *
 * LIMITE QUE NÃO DÁ PARA ESCONDER: quem digitar /checkout na barra de endereços pula
 * tudo isto. Fecha dado velho, que é o que acontece; não fecha burla deliberada. Quem
 * fecharia é a validation function, bloqueada fora do Plus por ser app custom.
 */
(function () {
  'use strict';

  var ENDPOINT = '/apps/qty-handler/validar-carrinho';
  var TIMEOUT_MS = 6000;
  var ID_AVISO = 'estoque-checkout-aviso';

  function metrosDaLinha(item) {
    var p = item && item.properties;
    var q = p && (p._Quantidade || p['_Quantidade']);
    if (!q) return 0;
    // `_Quantidade` é gravado com PONTO ("1.0 metros"). Parse decimal direto — tratar
    // ponto como separador de milhar transformaria 1.0 em 10. Rastreia: bug estoque 10×.
    var n = parseFloat(String(q).replace(',', '.').replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : 0;
  }

  function limparAviso() {
    var el = document.getElementById(ID_AVISO);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function mostrarAviso(botao, mensagens) {
    limparAviso();
    var box = document.createElement('div');
    box.id = ID_AVISO;
    box.setAttribute('role', 'alert');
    box.style.cssText =
      'background:#fff4f4;border:1px solid #e0b4b4;border-radius:6px;padding:10px 12px;' +
      'margin:0 0 10px;color:#7d2b2b;font-size:1.3rem;line-height:1.45;text-align:left;';
    box.innerHTML = mensagens
      .map(function (m) {
        return '<div>' + String(m).replace(/[<>&]/g, function (c) {
          return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c];
        }) + '</div>';
      })
      .join('');
    botao.parentNode.insertBefore(box, botao);
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /*
   * "VALOR POR METRO" ATUALIZADO ANTES DO CHECKOUT.
   *
   * A propriedade é gravada quando o corte entra no carrinho e o checkout a mostra
   * como texto ("Valor por metro: R$ 9,96") ao lado do preço ATUAL da variante. Se a
   * promoção muda no meio, a cliente lê um valor e paga outro: no #5145 (24/09/2026)
   * duas linhas diziam R$ 9,96 e R$ 13,70 e foram cobradas a R$ 24,90/m. De 28/08 a
   * 14/10 foram 93 pedidos pagos acima do que a linha anunciava.
   *
   * O preço certo é o da variante ÷ metragem — a mesma conta do drawer e da /cart.
   * `original_price` e não `final_price`: o cupom da CBV é desconto na linha e o PIX é
   * automático; os dois aparecem separados no checkout, e embuti-los aqui deixaria o
   * texto errado assim que a cliente trocasse o cupom ou a forma de pagamento.
   *
   * Folga de 1 centavo: preço promocional com meio centavo (27,90 × 45%) faz a divisão
   * discordar da Padrão por arredondamento, e reescrever por isso só custaria uma ida.
   *
   * Reescrever as propriedades TROCA A CHAVE da linha, e duas linhas da mesma variante
   * que ficam iguais se FUNDEM. Por isso cada volta parte do carrinho devolvido pela
   * anterior, em vez de uma lista de chaves lida no começo.
   *
   * FALHA ABERTA, como o resto do arquivo: erro ou demora → segue para o checkout com
   * o texto antigo. Não cobre quem entra no checkout pelo link do e-mail de carrinho
   * abandonado, que não passa pelo tema — isso só fecharia com Plus.
   */
  var PROP_VPM = 'Valor por metro';
  var TIMEOUT_VPM_MS = 5000;

  function brl(n) {
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function centavosDaPropriedade(v) {
    var n = parseFloat(String(v || '').replace(/[^\d,]/g, '').replace(',', '.'));
    return isFinite(n) ? Math.round(n * 100) : NaN;
  }

  /** Centavos por metro que a linha deveria anunciar, ou null se não for corte. */
  function vpmCorreto(item) {
    var m = metrosDaLinha(item);
    var preco = Number(item && item.original_price);
    if (!(m >= 0.5) || !(preco > 0)) return null;
    return Math.round(preco / m);
  }

  function linhaDesatualizada(cart) {
    var itens = (cart && cart.items) || [];
    for (var i = 0; i < itens.length; i++) {
      var it = itens[i];
      var certo = vpmCorreto(it);
      if (certo == null || !it.properties || !(PROP_VPM in it.properties)) continue;
      var atual = centavosDaPropriedade(it.properties[PROP_VPM]);
      if (!isFinite(atual) || Math.abs(atual - certo) > 1) return { item: it, centavos: certo };
    }
    return null;
  }

  /** @returns {Promise<number>} quantas linhas foram reescritas */
  async function sincronizarValorPorMetro(cart) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, TIMEOUT_VPM_MS);
    var reescritas = 0;
    try {
      // Teto de voltas: cada uma conserta uma linha; o teto só existe para que uma
      // resposta inesperada (a Shopify recusando a propriedade, p.ex.) não vire laço.
      for (var volta = 0; volta < 60; volta++) {
        var alvo = linhaDesatualizada(cart);
        if (!alvo) break;
        var props = {};
        for (var k in alvo.item.properties) props[k] = alvo.item.properties[k];
        props[PROP_VPM] = brl(alvo.centavos / 100);
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: alvo.item.key, quantity: alvo.item.quantity, properties: props }),
          signal: ctrl.signal,
        });
        if (!res.ok) break;
        cart = await res.json();
        reescritas++;
      }
    } catch (e) { /* falha aberta */ }
    finally { clearTimeout(timer); }
    return reescritas;
  }

  /*
   * LINHA AINDA COMO "RESERVA N" — corte que sairia a preço de 1 metro.
   *
   * A reserva é uma variante de 1 metro que o app renomeia para virar corte
   * ("Reserva 1" → "6,5 metros", com o preço total). No #6663 (12/10/2026) o rename
   * deu certo, mas a linha entrou no carrinho com a foto antiga e fechou o pedido
   * 14 min depois: 6,5 m por R$ 11,96 em vez de R$ 77,74. O add já confere isso
   * (decimal-quantity.js); aqui é a segunda rede, para o carrinho montado antes dessa
   * conferência existir ou que escapou dela.
   *
   * Conserta sozinho: pede o corte de novo ao proxy, espera a vitrine servir o preço
   * certo e troca a linha. Só se não der em ~10 s é que mostra o aviso.
   *
   * ⚠️ Aqui a regra NÃO é falha aberta, ao contrário do resto do arquivo. Deixar seguir
   * é vender o tecido por uma fração do preço, sempre, e não "talvez faltar estoque".
   */
  var RESERVA_RE = /^reserva\s+\d+$/i;
  var ESPERA_RESERVA_MS = 10000;

  function fmtMetros(m) {
    return m.toFixed(1).replace('.', ',');
  }

  /** @returns {Promise<{ok:boolean, cart?:object, mudou?:boolean, mensagens?:string[]}>} */
  async function consertarReservas(cart) {
    var linhas = ((cart && cart.items) || []).filter(function (it) {
      return RESERVA_RE.test(String(it.variant_title || '').trim());
    });
    if (!linhas.length) return { ok: true, cart: cart, mudou: false };

    var DC = window.DecimalCut;
    var mensagens = [];
    var mudou = false;
    for (var i = 0; i < linhas.length; i++) {
      var it = linhas[i];
      var m = metrosDaLinha(it);
      var consertou = false;
      if (DC && DC.resolverCorte && m >= 0.5) {
        try {
          // O preço/metro aqui é só referência de log: o servidor calcula pela Padrão.
          var id = await DC.resolverCorte(it.product_id, m, it.product_title, it.original_price / 100 / m, { timeoutMs: 6000, maxTentativas: 1 });
          var centavos = DC.precoEsperado(id);

          /*
           * SÓ O TÍTULO ATRASADO — a linha está certa, segue (medido 16/10/2026).
           *
           * Depois de TODA metragem inédita (sempre uma Reserva renomeada) o /cart.js
           * alterna por até ~1 min entre "Reserva N" e o título certo, já com o preço
           * certo. Trocar a linha não adianta (o /cart.js seguiu dizendo "Reserva 2"
           * depois da troca), custava 3-7 s no clique e, se o add falhasse, o tecido.
           * E o checkout lê a variante na fonte: aberto nessa janela, 4 de 4 vezes
           * mostrou o título e o preço certos ("6,3 metros", R$ 37,61) com o /cart.js
           * dizendo "Reserva 3" um instante antes.
           *
           * O #6663 é outro caso: lá o PREÇO da linha era o da reserva (R$ 11,96 por
           * 6,5 m). Aqui a conferência é a mesma variante que o proxy devolve E o preço
           * da linha igual ao que o proxy diz que ela tem.
           */
          if (String(id) === String(it.variant_id) && centavos > 0 && Math.abs(Number(it.original_price) - centavos) <= 1) {
            consertou = true;
          }

          /*
           * ADICIONA A NOVA PRIMEIRO, e só então tira a antiga pela chave (16/10/2026).
           * Era o contrário: removia a "Reserva N" e depois chamava o cartAdd; se ele
           * recusasse (422, 429, a conferência de preço) a devolução da original era um
           * add sem conferência — se também levasse 429, o tecido sumia do carrinho sem
           * aviso. Variantes diferentes nunca se fundem, então a ordem é segura. Mesma
           * variante com preço errado não tem troca que conserte (re-adicionar a mesma
           * variante funde e o remove apagaria as duas): não mexe, e o aviso barra.
           */
          if (!consertou && String(id) !== String(it.variant_id)) {
            var pronta = await DC.esperarVariantePronta(it.handle, id, ESPERA_RESERVA_MS);
            if (pronta) {
              var ppm = centavos > 0 ? centavos / 100 / m : it.original_price / 100 / m;
              await DC.cartAdd(id, m, ppm, it.properties && it.properties.SKU);
              mudou = true;
              var tirou = false;
              for (var t = 0; t < 3 && !tirou; t++) {
                if (t) await new Promise(function (r) { setTimeout(r, 1000 * t); });
                try {
                  var rem = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: it.key, quantity: 0 }),
                  });
                  tirou = rem.ok;
                } catch (e2) { /* tenta de novo */ }
              }
              // a "Reserva N" ficou junto da nova: segue barrado pelo aviso abaixo — a
              // cliente vê as duas linhas e não fecha a preço de 1 metro
              consertou = tirou;
            }
          }
        } catch (e) {
          /* cartAdd recusou: nada foi removido, a linha original segue no carrinho e o
             aviso abaixo barra o checkout */
        }
      }
      if (!consertou) {
        mensagens.push(
          'O preço do corte de ' + it.product_title + ' (' + fmtMetros(m) + ' m) ainda está sendo atualizado. ' +
          'Aguarde alguns segundos e clique em finalizar a compra de novo. Se continuar, remova o item e adicione outra vez.',
        );
      }
    }
    if (mensagens.length) return { ok: false, mensagens: mensagens, mudou: mudou };

    var novo = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    return { ok: true, cart: novo, mudou: mudou };
  }

  /** Segue para o checkout do jeito que ESTE botão faria sozinho. */
  function prosseguir(botao, carrinhoMudou) {
    if (botao.tagName === 'A' && botao.href) { window.location.assign(botao.href); return; }
    // O formulário da /cart manda `updates[]` POR POSIÇÃO. Se uma linha foi reescrita
    // (ou fundida com outra), a ordem e a contagem que o HTML conhece já não são as do
    // carrinho, e reenviar o form mexeria em quantidade. Vai direto ao checkout.
    if (carrinhoMudou) { window.location.assign('/checkout'); return; }
    var form = botao.form || botao.closest('form');
    // `requestSubmit(botao)` — e não `form.submit()` — porque o botão do carrinho é
    // `name="checkout"`, e é esse par nome/valor que diz à Shopify para ir ao checkout
    // em vez de só atualizar o carrinho. `form.submit()` o descartaria.
    if (form && form.requestSubmit) { form.requestSubmit(botao); return; }
    if (form) { form.submit(); return; }
    window.location.assign('/checkout');
  }

  async function conferir() {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS);
    try {
      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: ctrl.signal })
        .then(function (r) { return r.json(); });

      /*
       * SOBRA DA CALCULADORA DE FRETE DA PDP (16/10/2026). Para cotar, ela põe o
       * tecido no carrinho com a property `_cotacao` e tira em seguida; se a aba
       * fechou no meio, a linha pode ter ficado. Nenhuma compra de verdade tem essa
       * property — então sai aqui, antes do checkout, sem pergunta.
       */
      var cotacoes = (cart.items || []).filter(function (it) { return it.properties && it.properties._cotacao; });
      if (cotacoes.length) {
        for (var c = 0; c < cotacoes.length; c++) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: cotacoes[c].key, quantity: 0 }),
              signal: ctrl.signal,
            });
          } catch (e) { /* segue: a releitura abaixo diz o que ficou */ }
        }
        try { localStorage.removeItem('cbv:cotacao-pdp'); } catch (e) {}
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: ctrl.signal })
          .then(function (r) { return r.json(); });
      }

      var itens = (cart.items || [])
        .map(function (it, i) {
          return {
            productId: 'gid://shopify/Product/' + it.product_id,
            metros: metrosDaLinha(it),
            quantidade: it.quantity || 1,
            indice: i,
          };
        })
        // Produto comum (sem metragem) é controlado pelo estoque nativo da Shopify —
        // mandar essas linhas só faria o servidor buscar metacampo que não existe.
        .filter(function (l) { return l.metros > 0; });

      if (!itens.length) return { ok: true, faltas: [], cart: cart, cotacaoTirada: cotacoes.length > 0 };

      var res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ itens: itens }),
        signal: ctrl.signal,
      });
      /*
       * Falha aberta NO ESTOQUE, mas o carrinho já lido segue junto (16/10/2026): sem
       * ele, o clique pulava também a checagem de "Reserva N" (consertarReservas), que
       * NÃO é falha aberta. Medido: com o validar-carrinho caindo numa máquina do app
       * sem rede, uma linha "Reserva 6" de 2,0 m a R$ 20,93 (preço de 1 m) foi direto ao
       * checkout — a classe do #6663.
       */
      if (!res.ok) return { ok: true, faltas: [], cart: cart, cotacaoTirada: cotacoes.length > 0 }; // falha aberta
      var data = await res.json();
      var r = data && typeof data.ok === 'boolean' ? data : { ok: true, faltas: [] };
      r.cart = cart; // reaproveitado pelo "Valor por metro", sem reler o carrinho
      r.cotacaoTirada = cotacoes.length > 0;
      return r;
    } catch (e) {
      return { ok: true, faltas: [], cart: cart }; // falha aberta (o carrinho, se lido, segue p/ a checagem de Reserva)
    } finally {
      clearTimeout(timer);
    }
  }

  document.addEventListener(
    'click',
    function (ev) {
      var botao = ev.target && ev.target.closest && ev.target.closest('.checkout-button');
      if (!botao) return;
      if (botao.disabled || botao.classList.contains('disabled')) return;
      if (botao.dataset.estoqueConferido === '1') return; // já passou: deixa seguir

      // Um clique já em conferência não vira uma segunda chamada. Antes quem impedia
      // isso era o `disabled` do botão; sem ele, a trava passa a ser esta marca.
      if (botao.dataset.estoqueConferindo === '1') {
        ev.preventDefault();
        ev.stopPropagation();
        return;
      }

      ev.preventDefault();
      ev.stopPropagation();
      limparAviso();

      /*
       * NÃO trocar o texto nem desabilitar o botão (29/07/2026, a pedido do Gilberto).
       * O botão mostrava "Conferindo estoque…" e ficava cinza — o cliente via o passo
       * interno de uma rede de segurança que, na esmagadora maioria dos cliques, apenas
       * aprova em ~300ms. Chamar atenção para uma checagem que quase sempre passa só
       * planta dúvida na hora de pagar.
       *
       * Tirar SÓ o texto e manter o `disabled` seria pior: o botão ficaria apagado e
       * mudo por até 6s (o teto do timeout), parecendo travado. Por isso o botão agora
       * não muda de aparência nenhuma; a conferência é invisível e só se manifesta
       * quando REPROVA, aí sim com o aviso vermelho.
       */
      botao.dataset.estoqueConferindo = '1';

      conferir().then(function (r) {
        delete botao.dataset.estoqueConferindo;

        if (r.ok) {
          // Sem carrinho lido (falha aberta na conferência), não há o que comparar.
          var reservas = r.cart ? consertarReservas(r.cart) : Promise.resolve({ ok: true, cart: null, mudou: false });
          return reservas.then(function (rv) {
            if (!rv.ok) {
              mostrarAviso(botao, rv.mensagens);
              document.dispatchEvent(new CustomEvent('cart:updated'));
              return;
            }
            // Marca ANTES de reenviar para não cair de novo neste mesmo handler. Some
            // sozinho: o drawer reconstrói o botão a cada atualização do carrinho.
            botao.dataset.estoqueConferido = '1';
            var sinc = rv.cart ? sincronizarValorPorMetro(rv.cart) : Promise.resolve(0);
            return sinc.then(
              function (n) { prosseguir(botao, rv.mudou || n > 0 || r.cotacaoTirada); },
              function () { prosseguir(botao, rv.mudou || r.cotacaoTirada); },
            );
          });
        }

        mostrarAviso(botao, r.faltas.map(function (f) { return f.mensagem; }));
        // O carrinho na tela está mostrando número velho — foi por isso que o clique
        // chegou aqui. Pedir para ele se redesenhar evita o cliente tentar de novo e
        // levar a mesma recusa sem entender o que mudou.
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }).catch(function () {
        /*
         * `conferir()` já trata os próprios erros e nunca deveria rejeitar. Mas se algo
         * inesperado escapar (um erro dentro de `mostrarAviso`, por exemplo), a marca
         * ficaria presa e o botão de finalizar pararia de funcionar PARA SEMPRE naquela
         * página — checkout travado é bem pior do que estoque conferido a mais. Solta a
         * marca e segue, mesma escolha de falha aberta do resto do arquivo.
         */
        delete botao.dataset.estoqueConferindo;
        botao.dataset.estoqueConferido = '1';
        prosseguir(botao);
      });
    },
    true, // captura: precisa decidir antes de qualquer handler do tema
  );
})();
